import { Controller } from "stimulus"

export default class extends Controller {
  connect() {}

  toggleDistributors({ target }) {
    const distributorFields = document.getElementById('distributors-fields');

    if(target.value == 'distributor_manager') {
      distributorFields.classList.remove('d-none');
    } else {
      distributorFields.classList.add('d-none');
    }
  }
}
